export default __webpack_public_path__ + "5769a0fce4ce87212d52cbbf218911a6.svg";